<template>
    <nav class="navbar">
        <slot />
        <span
            class="ml-5 d-none d-md-block"
            v-html="course.title" />
    </nav>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AppNavbar",
  computed: mapGetters({ course: "getCourse" }),
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables";

.navbar {
  background: $white;
  box-shadow: 0px 2px 16px rgba(0, 18, 63, 0.16);
  height: 70px;
  z-index: 3;
  .container {
    flex-wrap: nowrap;
  }
  h1 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: $text-dark;
  }
  span {
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
